
<script>
const serviceCostListReport = importVueComp('components/reports', 'ServiceCostListReport', 'custom');
export default {
    name: "custom-service-costlist-report",
    mixins: [serviceCostListReport],
    mounted() {
        this.columnsClasses.ServiceName += ' text-left';
        Object.assign({}, this.columnsClasses)
    },
}
</script>
